module.exports = {"420822100":"沙洋镇","420822101":"五里铺镇","420822102":"十里铺镇","420822103":"纪山镇","420822104":"拾回桥镇","420822105":"后港镇","420822106":"毛李镇","420822107":"官当镇","420822108":"李市镇","420822109":"马良镇","420822110":"高阳镇","420822111":"沈集镇","420822112":"曾集镇","420822450":"沙洋监狱管理局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420822.json
// module id = 1753
// module chunks = 0